import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.a6v_1 = id;
        this.b6v_1 = name;
        this.c6v_1 = email;
        this.d6v_1 = badge;
        this.e6v_1 = callSignAdjective;
        this.f6v_1 = callSignNoun;
        this.g6v_1 = imageURL;
        this.h6v_1 = avatarType;
        this.i6v_1 = unvalidatedEmails;
        this.j6v_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.a6v_1.toString() + ', name=' + this.b6v_1 + ', email=' + this.c6v_1 + ', badge=' + toString(this.d6v_1) + ', callSignAdjective=' + this.e6v_1 + ', callSignNoun=' + this.f6v_1 + ', imageURL=' + toString(this.g6v_1) + ', avatarType=' + toString(this.h6v_1) + ', unvalidatedEmails=' + toString(this.i6v_1) + ', pins=' + toString(this.j6v_1) + ')';
      }
      hashCode() {
        var result = this.a6v_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.b6v_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c6v_1) | 0;
        result = imul(result, 31) + hashCode(this.d6v_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e6v_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.f6v_1) | 0;
        result = imul(result, 31) + hashCode(this.g6v_1) | 0;
        result = imul(result, 31) + hashCode(this.h6v_1) | 0;
        result = imul(result, 31) + hashCode(this.i6v_1) | 0;
        result = imul(result, 31) + hashCode(this.j6v_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.a6v_1.equals(other.a6v_1))
          return false;
        if (!(this.b6v_1 === other.b6v_1))
          return false;
        if (!(this.c6v_1 === other.c6v_1))
          return false;
        if (!equals(this.d6v_1, other.d6v_1))
          return false;
        if (!(this.e6v_1 === other.e6v_1))
          return false;
        if (!(this.f6v_1 === other.f6v_1))
          return false;
        if (!equals(this.g6v_1, other.g6v_1))
          return false;
        if (!equals(this.h6v_1, other.h6v_1))
          return false;
        if (!equals(this.i6v_1, other.i6v_1))
          return false;
        if (!equals(this.j6v_1, other.j6v_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
